<template>
  <div class="add-sibling-wrapper">
    <!-- Show loading indicator until groups are loaded -->
    <div v-if="loading" class="text-center py-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Betöltés...</span>
      </div>
    </div>

    <!-- Button to start adding a new child -->
    <div v-if="!isEditing && !loading" class="action-bar-center">
      <button class="add-sibling-btn" @click="startEditing">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        <span>Új testvér (táncos) felvétele</span>
      </button>
    </div>

    <!-- Display form if editing and groups are loaded -->
    <div v-if="isEditing && !loading && grps.length > 0" class="add-sibling-card">
      <div class="card-header-bar">
        <div class="header-icon-mini">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="8.5" cy="7" r="4"/>
            <line x1="20" y1="8" x2="20" y2="14"/>
            <line x1="17" y1="11" x2="23" y2="11"/>
          </svg>
        </div>
        <h3 class="form-title">Új testvér (táncos) adatai</h3>
      </div>

      <form @submit.prevent="submitForm" class="sibling-form">
        <div class="form-grid">
          <div class="form-group-item">
            <label for="vezeteknev" class="form-label">Vezetéknév</label>
            <input
              type="text"
              id="vezeteknev"
              v-model="form.vezeteknev"
              class="modern-input"
              required
              placeholder="Vezetéknév"
            />
          </div>
          <div class="form-group-item">
            <label for="keresztnev" class="form-label">Keresztnév</label>
            <input
              type="text"
              id="keresztnev"
              v-model="form.keresztnev"
              class="modern-input"
              required
              placeholder="Új testvér keresztneve"
            />
          </div>
          <div class="form-group-item">
            <label for="lakhely" class="form-label">Lakhely</label>
            <input
              type="text"
              id="lakhely"
              v-model="form.lakhely"
              class="modern-input"
              required
              placeholder="Cím / Lakhely"
            />
          </div>
          <div class="form-group-item">
            <label for="dancerEmail" class="form-label">Táncos saját email címe <span class="optional-tag">(opcionális)</span></label>
            <input
              type="email"
              id="dancerEmail"
              v-model="form.dancer_email"
              class="modern-input"
              placeholder="Ha az új táncosnak saját emailje van"
            />
          </div>
          <div class="form-group-item full-width">
            <label for="csoport" class="form-label">Kívánt csoport</label>
            <select
              id="csoport"
              v-model="form.csoport"
              class="modern-select"
              required
            >
              <option :value="null" disabled>Válassz csoportot...</option>
              <option v-for="group in grps" :key="group.id" :value="group.id">
                {{ group.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="modern-btn modern-btn--primary">
            Mentés
          </button>
          <button type="button" class="modern-btn modern-btn--secondary" @click="cancelForm">
            Mégse
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    parent_1_mail: {
      type: String,
      default: ''
    },
    parent_2_mail: {
      type: String,
      default: ''
    },
    default_familyname: {
      type: String,
      default: ''
    },
    default_addr: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isEditing: false,
      loading: false,
      form: {
        vezeteknev: '',
        keresztnev: '',
        lakhely: '',
        dancer_email: '',
        csoport: null
      },
      grps: [],
    };
  },
  methods: {
    startEditing() {
      this.form.vezeteknev = this.default_familyname || '';
      this.form.lakhely = this.default_addr || '';
      this.loading = true;
      axios.get(`${this.$BACKEND_HOST}/api/settings/groups/info`)
        .then(response => {
          this.grps = response.data.groups;
          this.loading = false;
          this.isEditing = true;
        })
        .catch(err => {
          console.error('Error fetching groups:', err.message);
          this.loading = false;
        });
    },
    
    submitForm() {
      const postData = {
        child_familyname: this.form.vezeteknev,
        child_surename: this.form.keresztnev,
        child_addr: this.form.lakhely,
        child_desired_grp: this.form.csoport,
        dancer_email: this.form.dancer_email,
        p1_mail: this.parent_1_mail,
        p2_mail: this.parent_2_mail
      };

      axios.post(`${this.$BACKEND_HOST}/api/addnewchild`, postData)
        .then(response => {
          this.showToast('Új testvér (táncos) sikeresen rögzítve!', 'success');
          this.$emit('child-added', response.data);
          this.isEditing = false;
          this.resetForm();
        })
        .catch(err => {
          console.error('Error submitting form:', err.message);
          this.showToast('Hiba történt a rögzítés során: ' + (err.response?.data?.message || err.message), 'error');
        });
    },

    cancelForm() {
      this.isEditing = false;
      this.resetForm();
    },

    resetForm() {
      this.form = {
        vezeteknev: this.default_familyname || '',
        keresztnev: '',
        lakhely: this.default_addr || '',
        dancer_email: '',
        csoport: null
      };
    }
  }
};
</script>

<style scoped>
.add-sibling-wrapper {
  margin: 1rem 0 1.5rem 0;
}

.action-bar-center {
  display: flex;
  justify-content: center;
}

.add-sibling-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.75rem;
  background: var(--button-primary, #2563eb);
  color: #ffffff;
  font-weight: 600;
  font-size: 0.95rem;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: var(--shadow, 0 4px 6px -1px rgba(0, 0, 0, 0.1));
  transition: all 0.25 ease;
}

.add-sibling-btn:hover {
  background: var(--button-primary-hover, #1d4ed8);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md, 0 6px 12px -2px rgba(0, 0, 0, 0.15));
}

.add-sibling-card {
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 16px;
  padding: 1.75rem;
  box-shadow: var(--card-shadow, 0 4px 12px rgba(0,0,0,0.05));
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.card-header-bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--color-border, #e5e7eb);
}

.header-icon-mini {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: var(--button-primary, #2563eb);
  color: white;
  border-radius: 10px;
}

.form-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--color-heading, #111827);
}

.sibling-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.25rem;
}

.form-group-item {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.form-group-item.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--color-text, #374151);
}

.optional-tag {
  font-weight: 400;
  color: var(--color-text-muted, #6b7280);
  font-size: 0.8rem;
}

.modern-input, .modern-select {
  width: 100%;
  padding: 0.7rem 1rem;
  border: 1px solid var(--color-border, #d1d5db);
  border-radius: 10px;
  background: var(--color-background-soft, #f9fafb);
  color: var(--color-text, #111827);
  font-size: 0.95rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.3s ease;
}

.modern-input:focus, .modern-select:focus {
  outline: none;
  border-color: var(--button-primary, #2563eb);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  background: var(--card-bg, #ffffff);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.modern-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.modern-btn--primary {
  background: var(--button-primary, #2563eb);
  color: white;
}

.modern-btn--primary:hover {
  background: var(--button-primary-hover, #1d4ed8);
  transform: translateY(-1px);
}

.modern-btn--secondary {
  background: var(--color-background-mute, #f3f4f6);
  color: var(--color-text, #374151);
  border: 1px solid var(--color-border, #d1d5db);
}

.modern-btn--secondary:hover {
  background: var(--color-border, #e5e7eb);
}
</style>
